import React from "react";
import { useNavigate } from "react-router";
import { CustomButton } from "../../components/customButton/CustomButton";

const ConfirmationModal = () => {
  const navigate = useNavigate();
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
        alignItems: "center",
        padding: "20px",
      }}
    >
      <p style={{ margin: "0px" }}> Documents uploaded successfully</p>
      <p style={{ fontSize: 13, margin: "0px", marginTop: 10 }}>
        {" "}
        Support team will get back to you with the credentials!
      </p>

      <CustomButton
        title={"Done"}
        styles={{ background: "#38369C", border: "0px", marginTop: "20px" }}
        onClick={() => navigate("/login")}
      />
    </div>
  );
};

export default ConfirmationModal;
